/* tslint:disable */
/**
 * This file is autogenerated using @sharefiledev/solution-view-engine-tools.
 *
 * Run 'sve typegen <relative path to manifest file>'
 *
 * Types are generated according to specification in a file that conforms to the UI Manifest schema:
 * https://us-solutionviewengine.sharefiletest.io/ui-manifest-v2.json
 */
import type {
	PiletApi,
	PiralCustomExtensionSlotMap as ShellPiralCustomExtensionSlotMap,
} from '@sharefiledev/sharefile-appshell';
import type { BlockParams } from '@sharefiledev/solution-view-engine';

export interface ShellProps {
	piletApi: PiletApi;
}
/** Block parameters for urn:block:conversations:viewer */

export interface ViewerBlockParams {
	/**
	 * The unique identifier for the container resource.
	 */
	containerRID: string;
	/**
	 * Flag to enable or disable filters in the conversation viewer.
	 */
	enableFilters?: boolean;
	/**
	 * The tracking ID used for analytics purposes.
	 */
	originAnalyticsTrackingId?: string;
	/**
	 * Indicates whether the conversation viewer is displayed as a tile.
	 */
	isTile?: boolean;
	/**
	 * Indicates whether the conversation viewer should be in a frozen or read-only state
	 */
	isFrozen?: boolean;
	/**
	 * The tab path used for navigation when interacting with conversation elements.
	 */
	tabPath?: string;
	/**
	 * Controls whether to show the enhanced empty state with action button.
	 */
	showEmptyStateWithButton?: boolean;
	/**
	 * Controls which user roles are allowed to be mentioned.
	 */
	allowedMentionRoles?: string[];
}

export namespace BlockNames {
	export const Viewer = 'urn:block:conversations:viewer' as const;
	export type Viewer = 'urn:block:conversations:viewer';
}

export namespace ZoneTypes {}

export type ViewerProps = ShellProps & BlockParams & ViewerBlockParams;

declare module '@sharefiledev/sharefile-appshell' {
	interface PiralCustomExtensionSlotMap {
		['urn:block:conversations:viewer']: BlockParams & ViewerBlockParams;
	}
}

declare module '@sharefiledev/solution-view-engine' {
	interface BlockCustomExtensionSlotMap extends ShellPiralCustomExtensionSlotMap {}

	interface PiletExtensionApi extends PiletApi {}

	interface ViewEngineCustomZoneParametersMap {}

	interface ViewEngineCustomZoneContractDataMap {}
}
